export default __webpack_public_path__ + "static/muscle_small-76947abe9c698a112481b03ef775e149.webp";